<rcl-modal
	id="exit-confirmation-rcl-modal"
	[show]="exitConfirmationModal"
	[attr.aria-hidden]="!exitConfirmationModal"
	tabindex="-1"
	(onClose)="closeModal()"
	[mobileFullScreen]="false"
>
	<rcl-modal-content id="exit-confirmation-rcl-modal__content" tabindex="0">
		<rcl-modal-title id="exit-confirmation-rcl-modal__content__title">
			{{ (bundle && bundle['message.modal.leaving.olci.header']) || 'Leaving check-in?' }}
		</rcl-modal-title>
		<p id="exit-confirmation-rcl-modal__content__subheader" class="rcl-center-md rcl-p">
			{{
				(bundle && bundle['message.modal.leaving.olci.subheader']) ||
					'You can come back at any time. All completed information will be saved.'
			}}
		</p>
	</rcl-modal-content>

	<rcl-modal-actions id="exit-confirmation-rcl-modal__actions">
		<button id="exit-confirmation-rcl-modal__actions__continue-no" (click)="closeModal()" class="rcl-button-secondary">
			{{ (bundle && bundle['button.no']) || 'No' }}
		</button>
		<button id="exit-confirmation-rcl-modal__actions__continue-yes" (click)="yesContinue()" class="rcl-button-tertiary">
			{{ (bundle && bundle['expense.account.button.add.more.guests.yes']) || 'Yes' }}
		</button>
	</rcl-modal-actions>
</rcl-modal>
